import React, { useEffect, useState } from 'react';
import { Range, getTrackBackground } from 'react-range';
import '../../../assets/css/price-range-slider.css';

const MIN = 0;

function normalizeMaxPrice(value) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return null;
  }
  return Math.ceil(parsed);
}

function clampValues(values, maxValue) {
  return [
    Math.max(MIN, Math.min(values[0], maxValue)),
    Math.min(maxValue, Math.max(values[1], MIN)),
  ];
}

function formatPrice(value, currencySymbol) {
  return `${currencySymbol}${Number(value).toLocaleString('en-US', {
    maximumFractionDigits: 0,
  })}`;
}

const RangeTwoThumbs = ({ sendRanges, currencySymbol = '$', MAX }) => {
  const maxValue = normalizeMaxPrice(MAX);
  const [values, setValues] = useState(() =>
    maxValue ? [MIN, maxValue] : [MIN, MIN]
  );

  useEffect(() => {
    if (!maxValue) return;
    setValues([MIN, maxValue]);
  }, [maxValue]);

  const handleChange = (nextValues) => {
    if (!maxValue) return;
    setValues(clampValues(nextValues, maxValue));
  };

  const handleFinalChange = (finalValues) => {
    if (!maxValue) return;

    const nextValues = clampValues(finalValues, maxValue);
    setValues(nextValues);
    sendRanges(nextValues);
  };

  if (!maxValue) {
    return null;
  }

  return (
    <div className="price-range-slider">
      <Range
        key={maxValue}
        allowOverlap={false}
        values={values}
        step={1}
        min={MIN}
        max={maxValue}
        onChange={handleChange}
        onFinalChange={handleFinalChange}
        renderTrack={({ props, children }) => (
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            className="price-range-slider__track-wrap"
            style={{
              ...props.style,
            }}
          >
            <div
              ref={props.ref}
              className="price-range-slider__track"
              style={{
                background: getTrackBackground({
                  values,
                  colors: ['#E8E8E8', '#FBB500', '#E8E8E8'],
                  min: MIN,
                  max: maxValue,
                }),
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props }) => (
          <div
            {...props}
            className="price-range-slider__thumb"
            style={{
              ...props.style,
            }}
          />
        )}
      />
      <div className="price-range-slider__values" aria-live="polite">
        <span>{formatPrice(values[0], currencySymbol)}</span>
        <span>{formatPrice(values[1], currencySymbol)}</span>
      </div>
    </div>
  );
};

export default RangeTwoThumbs;
